module.exports = __webpack_public_path__ + "static/media/failed.769ff028.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Svgs/import-status-icons/failed.svg
// module id = 7682
// module chunks = 0